import { useEffect, useState } from "react";
import { FacilityDataTypes } from "../types/facilitiy-data-types";
import api, {apiV2} from "../api/axiosConfig";
import { useInfiniteQuery, useQuery } from "react-query";
import { MapFacility } from "@/features/map/layers/useFacilitiesLayer";

export default function useFacilities(querykey: string, params: {} = {}) {
  const [allFacilities, setAllFacilities] = useState<FacilityDataTypes[]>([]);
  const fetchIncidents = async (page: number) => {
    const response = await apiV2.get(`/facilities?page=${page}`, { params });
    return response.data;
  };

  const { data, fetchNextPage, hasNextPage, isFetching, isLoading, status } =
    useInfiniteQuery(
      querykey,
      ({ pageParam = 1 }) => fetchIncidents(pageParam),
      {
        getNextPageParam: (lastPage, allPages) => {
          if (lastPage.hasMore) {
            return allPages.length + 1;
          }
          return undefined;
        },
      }
    );

  useEffect(() => {
    if (hasNextPage) {
      fetchNextPage();
      return;
    }
  }, [data, hasNextPage, fetchNextPage]);

  useEffect(() => {
    if (hasNextPage) return;
    const flatItems = data ? data.pages?.flatMap((page) => page.items) : [];
    setAllFacilities(flatItems);
  }, [data, hasNextPage]);

  return {
    facilities: allFacilities,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading,
    status,
  };
}


export function useMapFacilities() {
  const { data } = useQuery<MapFacility[]>(
    ["facilities-sites-map"],
    async () => {
      const res = await apiV2.get("ops/facilities");
      return res.data ?? [];
    }
  );

  return { facilities: data ?? [] };
}


export function useFacilitiesV1(querykey: string, params: {} = {}) {
  const [allFacilities, setAllFacilities] = useState<FacilityDataTypes[]>([]);
  const fetchIncidents = async (page: number) => {
    const response = await api.get(`/facilities?page=${page}`, { params });
    return response.data;
  };

  const { data, fetchNextPage, hasNextPage, isFetching, isLoading, status } =
      useInfiniteQuery(
          querykey,
          ({ pageParam = 1 }) => fetchIncidents(pageParam),
          {
            getNextPageParam: (lastPage, allPages) => {
              if (lastPage.hasMore) {
                return allPages.length + 1;
              }
              return undefined;
            },
          }
      );

  useEffect(() => {
    if (hasNextPage) {
      fetchNextPage();
      return;
    }
  }, [data, hasNextPage, fetchNextPage]);

  useEffect(() => {
    if (hasNextPage) return;
    const flatItems = data ? data.pages?.flatMap((page) => page.items) : [];
    setAllFacilities(flatItems);
  }, [data, hasNextPage]);

  return {
    facilities: allFacilities,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading,
    status,
  };
}
